export default {
    player: {
        speed: "Playback speed"
    },
    footer: {
        copy: "{{year}} Shas Illuminated"
    },
    partners: {
        heading: "We thank our Sponsors"
    },
    newsletter: {
        heading: "Sign up for daily Shiurim",
        signUp: "Sign Up",
        thanks: "Thank You For Subscribing."
    },
    auth: {
        welcome:
            "Welcome to Shas Illuminated. Please register/sign in to download, follow speakers and save shiurim to your library. All shiurim are free. We hope you enjoy the shiurim.",
        subtitle:
            "We will not share your information with anyone. By signing up you agree to get occasional emails from Shas Illuminated.",
        confirmation:
            "We have sent a confirmation link to your registered email address ({{email}}). Please confirm your email to complete your registration.",
        verifyModalTitle: "Verify your phone",
        verifyModalText: "Dear listener,<br/>Shas Illuminated is currently developing a new app which will soon be available.<br/>We have made a few changes and updated our login/register system. We're sorry for the inconvenience but all phone numbers must be re-verified to use the system. We hope you continue to enjoy the shiurim.<br/>Shas Illuminated",
        verifyModalOkTitle: "Verify now",
        verifyModalCancelTitle: "Verify later",
        phoneFieldDescription: 'Alphabets, dashes and other special characters are not allowed.',
        registerPhoneFieldDescription: 'Please make sure you put the correct phone number. You will need to verify your phone to sign up.'
    },
    search: {
        heading: "Search Shas Illuminated",
        found: "Found {{count}} items for ",
        showPerPage: "Show Per Page:",
        shasShiurim: "Shas Shiurim",
        mishnaShiurim: "Mishna Shiurim"
    },
    speakerTab: {},
    bio: {
        follow: {
            tooltip:
                "Following a speaker will subscribe you to get their shiurim updates via email."
        }
    },
    magideiShiurList: {
        filterLabel: "Filter Magidei Shiur on Torah",
        filterMagidShiur: "Filter Magidei Shiur"
    },
    savedShiurim: {
        heading: "Saved Shiurim",
        bookmarkCaption:
            "You can bookmark you favorite shiurim and they will appear here."
    },
    inProgressShiurim: {
        heading: "In Progress Shiurim",
        bookmarkCaption:
            "The shiurim you have watched and didn't finish will appear here."
    },
    followingSpeaker: {
        heading: "Following Speaker",
        howOften:
            "How often do you want to recieve new shiurim updates for these speakers via email?",
        caption:
            "You can follow your favorite speakers and they will appear here."
    },
    contactForm: {
        heading: "COMMENTS & SUGGESTIONS",
        validationMessage:
            "This is a required field and must be at least 3 characters",
        requiredMessage: "This is a required field.",
        successMessage:
            "Thank you for your message, we will get back to you as soon as possible."
    },
    masechtos: {
        selectMasechta: "Select A Masechta"
    },
    seder: {
        heading: "Seder {{- name }}"
    },
    masechta: {
        volume: "Vol {{ number }}",
        dedicatedBy: "Dedicated By:",
        anonymous: "Anonymous",
        downloadMasechta:
            "Download the Masechta {{ name }} with Mar'ei Mekomos",
        downloadAllMasechta:
            "Download the entire Masechta {{masechta.name}} with Mar'ei Mekomos",
        downloadVolMasechta:
            "Download the Masechta {{ name }} Vol. {{ vol }} with Mar'ei Mekomos",
        downloadVol: "Download Vol. {{ num }}"
    },

    serverTable: {
        count:
            "Showing {from} to {to} of {count} records|{count} records|One record",
        first: "First",
        last: "Last",
        filter: "Filter:",
        filterPlaceholder: "Search query",
        limit: "Records:",
        page: "Page:",
        noResults: "No matching records",
        filterBy: "Filter by {column}",
        loading: "Loading...",
        defaultOption: "Select {column}",
        columns: "Columns",
        records: "No records"
    }
};
